import { usePostHttp } from "../../../../hooks/http/http.hook";

interface IBody {
  id: string;
  otp: string;
}

interface IResponse {
  token: string;
}

export function useEmailVerifyOtpBrandHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/authentication/email/otp/verify",
  });
}
